import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { PopupService } from '../../services/popup.service';
import { isPlatformBrowser } from '@angular/common';
import { PresaleDataService } from '../../services/connection-services/data.service';
import { CHAINS } from '../../shared/constants/app-enums';

@Component({
  selector: 'app-refer',
  templateUrl: './refer.component.html',
  styleUrls: ['./refer.component.scss'],
})
export class ReferComponent {
  walletAddress: string = '';
  originalUrl: string = '';

  constructor(
    public modalRef: BsModalRef,
    private popupService: PopupService,
    private translateService: TranslateService,
    private dataService: PresaleDataService,
    @Inject(PLATFORM_ID) private _platformId: Object,
  ) {
    this.dataService.$walletAddress.subscribe((item) => {
      this.walletAddress = this.dataService?.activeChain === CHAINS.SOL ? this.dataService.walletAddressSOL : this.dataService.walletAddress
    })
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      this.originalUrl = window.location.origin;
    }
  }

  get percentage(): number {
    return this.dataService.percentageReferral;
  }

  get url(): string {
    return this.originalUrl + "?referralAddress=" + this.walletAddress;
  }

  copy() {
    this.popupService.messsageAlert('success', this.translateService.instant('misc.successCopy'));
  }
}
